import { ComponentSlotStylesPrepared } from '@fluentui/styles';
import { DatepickerProps } from '../../../../components/Datepicker/Datepicker';
import { DatepickerVariables } from './datepickerVariables';

export const datepickerStyles: ComponentSlotStylesPrepared<DatepickerProps, DatepickerVariables> = {};
